module.exports = __webpack_public_path__ + "static/media/demo_email.4ed13134.png";